// Deep-links to a courier's own public tracking page, keyed off the free-
// text courier name stored on core_shipments (never a fixed enum — staff
// can type anything in the manual Ship modal). Steadfast's /t/<code> page
// works with just the tracking number; Pathao's tracking page requires the
// consignment ID *and* the recipient's phone number together, so there's
// no safe deep-link — this points at their general tracking page instead
// of guessing a query-string format that might silently be wrong.
export function courierTrackingUrl(courier: string | null, trackingNo: string | null): string | null {
  if (!trackingNo) return null;
  const c = (courier ?? '').toLowerCase();
  if (c.includes('steadfast')) return `https://steadfast.com.bd/t/${encodeURIComponent(trackingNo)}`;
  if (c.includes('pathao')) return 'https://merchant.pathao.com/';
  return null;
}
